import React from "react";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { WealthBeeLogo } from "@/assets/WealthBeeLogo";
import { formatFullTimestamp } from "../utils/format";
import { ReportingPeriod } from "@/types/ReportingPeriod";

interface ReportPeriodHeaderProps {
  selectedReportingPeriod: ReportingPeriod | undefined;
}

export const ReportPeriodHeader: React.FC<ReportPeriodHeaderProps> = ({
  selectedReportingPeriod,
}) => {
  if (!selectedReportingPeriod) {
    return (
      <Alert variant="default" className="mb-6">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>No reporting period selected</AlertTitle>
        <AlertDescription>
          Please select a reporting period to generate a report.
        </AlertDescription>
      </Alert>
    );
  }

  const runTimestamp = formatFullTimestamp();

  return (
    <div className="mb-4">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-xl font-semibold">Oversight Summary Report</h3>
          <p className="text-sm text-muted-foreground">Run date: {runTimestamp}</p>
          <p className="text-sm text-muted-foreground mt-1">
            Reporting period:{" "}
            <span className="font-medium">
              {new Date(selectedReportingPeriod.period).toLocaleDateString(
                "en-US",
                { year: "numeric", month: "long", day: "numeric" }
              )}
            </span>
          </p>
        </div>
        <WealthBeeLogo className="h-10 w-10" />
      </div>
    </div>
  );
}; 